import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const ShopIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 23 21"
      fill="none"
    >
      <path
        d="M3.98994 0.5C4.41963 0.5 4.81025 0.851562 4.88838 1.28125L4.9665 1.75H21.3728C22.1931 1.75 22.8181 2.57031 22.5837 3.35156L20.4743 10.8516C20.3181 11.3984 19.8493 11.75 19.2634 11.75H6.88057L7.23213 13.625H19.3024C19.8103 13.625 20.2399 14.0547 20.2399 14.5625C20.2399 15.1094 19.8103 15.5 19.3024 15.5H6.45088C6.02119 15.5 5.63057 15.1875 5.55244 14.7578L3.20869 2.375H1.17744C0.630567 2.375 0.239942 1.98438 0.239942 1.4375C0.239942 0.929688 0.630567 0.5 1.17744 0.5H3.98994ZM18.7946 9.875L20.5524 3.625H5.35713L6.529 9.875H18.7946ZM5.23994 18.625C5.23994 17.6094 6.06025 16.75 7.11494 16.75C8.13057 16.75 8.98994 17.6094 8.98994 18.625C8.98994 19.6797 8.13057 20.5 7.11494 20.5C6.06025 20.5 5.23994 19.6797 5.23994 18.625ZM20.2399 18.625C20.2399 19.6797 19.3806 20.5 18.3649 20.5C17.3103 20.5 16.4899 19.6797 16.4899 18.625C16.4899 17.6094 17.3103 16.75 18.3649 16.75C19.3806 16.75 20.2399 17.6094 20.2399 18.625Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default ShopIcon;
